import React, { useMemo, useState } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import useClock from "./hooks/useClock";
import { getNow } from "./utils/shared/time";
import { useEvents } from "./context/EventsContext";
import backArrow from "../assets/backArrow.svg";
import MarketingButton from "./components/MarketingButton";
import "./epg.scss";

const everpassLogo = `https://cdn.upshow.tv/ui-assets/EverPass_Horizontal_All_White.png`;

const BackButton = ({ goBack }) => {
    const { ref, focused } = useFocusable({
        focusKey: "BACK_BUTTON",
        onEnterPress: goBack,
    });

    return (
        <button ref={ref} className={`backBtn ${focused ? "focused" : ""}`} onClick={goBack} aria-label="Back" tabIndex={0}>
            <img src={backArrow} alt="Back" />
        </button>
    );
};

const EPGHeader = ({ goBack, closeEPG, showMarketingButton }) => {
    const [currentTime, setCurrentTime] = useState(getNow());
    const { showFiltered } = useEvents();

    useClock(setCurrentTime);

    const displayTime = useMemo(() => currentTime.format("hh:mm A"), [currentTime]);
    const rightSection = useMemo(
        () => (
            <div className="rightButtons">
                {showMarketingButton && <MarketingButton closeEPG={closeEPG} />}
                <h2>{displayTime}</h2>
            </div>
        ),
        [showMarketingButton, displayTime]
    );

    return (
        <div className="headerInfo">
            {showFiltered ? <BackButton goBack={goBack} /> : <img src={everpassLogo} alt="EverPass" />}
            {rightSection}
        </div>
    );
};

export default EPGHeader;
